import { useState } from 'react'

import {
  PayrollPayrollSummaryImport,
  PayrollPolicyFragment,
  PayrollPolicyPeriodFragment,
  PayrollSummaryImportModalDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import FileSelectorModal from './FileSelectorModal'
import ImportSummaryWizard from './ImportSummaryWizard'

interface Props {
  companyId: number
  initialPolicyId?: number
  initialPolicyPeriodId?: number
  initialPayrollResultDocumentId?: number
  initialPayrollResultDocumentFilename?: string
  source: string
  title?: string
  onFinish?: () => void
  onClose?: () => void
}

type PayrollSummaryModals = 'fileSelectorModal' | 'loading' | 'importSummaryWizard'

const PayrollSummaryImportModal = ({
  companyId,
  initialPolicyId,
  initialPolicyPeriodId,
  initialPayrollResultDocumentId,
  initialPayrollResultDocumentFilename = '',
  source,
  title,
  onFinish,
  onClose,
}: Props) => {
  const [currentModal, setCurrentModal] = useState<PayrollSummaryModals>('fileSelectorModal')
  const [payrollSummaryImport, setPayrollSummaryImport] = useState<
    PayrollPayrollSummaryImport | undefined
  >()
  const [payrollPolicy, setPayrollPolicy] = useState<PayrollPolicyFragment | undefined>()
  const [payrollPolicyPeriod, setPayrollPolicyPeriod] = useState<
    PayrollPolicyPeriodFragment | undefined
  >()
  const { data, loading } = useQuery(PayrollSummaryImportModalDocument, {
    variables: { companyId: companyId },
  })

  const payrollPolicies = data?.payroll.policiesConnection.nodes

  const onCloseModal = () => {
    onClose && onClose()
  }

  const onFinishFileSelector = (
    summaryImport: PayrollPayrollSummaryImport,
    policy?: PayrollPolicyFragment,
    period?: PayrollPolicyPeriodFragment
  ) => {
    setPayrollPolicy(policy)
    setPayrollPolicyPeriod(period)
    setPayrollSummaryImport(summaryImport)

    // Fix the problem of launching a modal without close the previous one
    setCurrentModal('loading')
    setTimeout(() => setCurrentModal('importSummaryWizard'), 100)
  }

  const onFinishSummaryWizard = () => {
    onFinish && onFinish()
    setCurrentModal('fileSelectorModal')
  }

  const onUpdateImportSummary = (summaryImport: PayrollPayrollSummaryImport) => {
    setPayrollSummaryImport(summaryImport)
  }

  if (!payrollPolicies) return <></>

  return (
    <>
      {currentModal === 'fileSelectorModal' && (
        <FileSelectorModal
          companyId={companyId}
          initialPolicyId={initialPolicyId}
          initialPolicyPeriodId={initialPolicyPeriodId}
          payrollPolicies={payrollPolicies}
          initialPayrollResultDocumentId={initialPayrollResultDocumentId}
          initialPayrollResultDocumentFilename={initialPayrollResultDocumentFilename}
          source={source}
          title={title}
          onClose={onCloseModal}
          onFinish={onFinishFileSelector}
          loading={loading}
        />
      )}

      {currentModal === 'loading' && <></>}

      {currentModal === 'importSummaryWizard' &&
        payrollSummaryImport &&
        payrollPolicy &&
        payrollPolicyPeriod && (
          <ImportSummaryWizard
            payrollPolicy={payrollPolicy}
            payrollPolicyPeriod={payrollPolicyPeriod}
            payrollSummaryImport={payrollSummaryImport}
            source={source}
            onUpdateImportSummary={onUpdateImportSummary}
            onClose={onCloseModal}
            onFinish={onFinishSummaryWizard}
          />
        )}
    </>
  )
}

export default PayrollSummaryImportModal
